import themes from '../../../weon/themes';

const state = {
  Validator: null,
  themes,
  notifications: [],
  snackbar: {
    timeout: 5000,
  },
  displayUsersConfigurations: false,
  serverTime: {},
  showDashboard: false,
  queueListenerMessageBroker: null,
  alerts: [],
  alertsNotRead: 0,
  systemFile: null,
  menuSelected: null,
  whitelabel: null,
};

export default state;
